import { render, staticRenderFns } from "./ConfirmarPagamentoModal.vue?vue&type=template&id=52860ad2&"
import script from "./ConfirmarPagamentoModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmarPagamentoModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmarPagamentoModal.vue?vue&type=style&index=0&id=52860ad2&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports